import { css } from 'styled-components';
import { CFBaseSearchbarTokens } from '..';
export const clearButtonMarginTop = ({ fieldSize, }) => {
    const physicalSize = CFBaseSearchbarTokens.BUTTON_PHYSICAL_SIZES[fieldSize.toUpperCase()];
    return physicalSize / 2;
};
export const clearButtonPosition = ({ fieldSize, }) => {
    return css `
    right: ${CFBaseSearchbarTokens.ROOT_PADDINGS[fieldSize.toUpperCase()]
        .FOCUSED.RIGHT}px;
    top: 50%;
  `;
};
export const decoratorAnimatedProperties = ({ exitDirection = 'down', visible, }) => {
    let translation;
    switch (exitDirection) {
        case 'right':
            translation = 'translateX(100%)';
            break;
        case 'left':
            translation = 'translateX(-100%)';
            break;
        case 'up':
            translation = 'translateY(-100%)';
            break;
        case 'down':
        default:
            translation = 'translateY(100%)';
            break;
    }
    return visible
        ? css `
        transform: translateY(0);
        opacity: 1;
      `
        : css `
        transform: ${translation};
        opacity: 0;
      `;
};
export const searchIconPosition = ({ fieldSize, }) => {
    return css `
    left: ${CFBaseSearchbarTokens.ROOT_PADDINGS[fieldSize.toUpperCase()].EMPTY
        .LEFT}px;
  `;
};
